export enum BookingStepType {
  Category = "category",
  Attribute = "attribute",
  EquipmentType = "equipment-type",
}
